import React from "react";
import { Field, useFormikContext } from "formik";
import { useTranslation } from "react-i18next";
import { SupplementsGroupFormValues } from "../SupplementsGroupModal";

interface MaxCountOnOrderProps {
    disabled?: boolean;
}

const MaxCountOnOrder: React.FC<MaxCountOnOrderProps> = ({ disabled }) => {
    const { t } = useTranslation();
    const { values, errors, touched, setFieldValue } = useFormikContext<SupplementsGroupFormValues>();

    const optionsCount = values.options?.length || 0;
    const maxAllowed = Math.max(optionsCount, 1);

    const handleChange: React.ChangeEventHandler<HTMLInputElement> = (event) => {
        const raw = event.target.value;

        if (raw.trim() === "") {
            setFieldValue("maxCountOnOrder", null);
            return;
        }

        const digitsOnly = raw.replace(/\D/g, "");
        if (!digitsOnly) {
            setFieldValue("maxCountOnOrder", null);
            return;
        }

        let next = Number(digitsOnly);

        if (!Number.isFinite(next)) {
            setFieldValue("maxCountOnOrder", null);
            return;
        }
        next = Math.floor(next);
        if (next < 1) next = 1;
        if (next > maxAllowed) next = maxAllowed;

        setFieldValue("maxCountOnOrder", next);
    };

    const error = errors.maxCountOnOrder as string | undefined;
    const isTouched = touched.maxCountOnOrder;

    const inputValue = values.maxCountOnOrder == null ? "" : String(values.maxCountOnOrder);
    return (
        <Field
            id="supplementsModal-maxCountOnOrder-field"
            name="maxCountOnOrder"
            type="text"
            placeholder={t("Max. quantity")}
            value={inputValue}
            onChange={handleChange}
            className={`form-control ${isTouched && error ? "is-invalid" : ""}`}
            disabled={disabled}
        />
    );
};

export default MaxCountOnOrder;
